import i18n from 'i18next';
import Cookies from 'js-cookie';
import { ICountryOption } from '../container/SearchVarieties/SearchVarieties';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import React from 'react';
import jwt_decode from 'jwt-decode';
import moment from 'moment';
import 'moment-timezone';
import { IDatePickerValue } from '../components/UI/CustomDatePicker/CustomDatePicker';
import graphQLClientInstance from '../axios-graphql-client';
//@ts-ignore
import gqlPrettier from 'graphql-prettier'

const createSearchParams = (values: any) => {
  const denomination = getValueFromFormControl(values.denomination, values.denominationSelect, "denomination",  "denominationSearchType");
  const registeredWithOther = ["0", "1"].includes(values.registeredWithOther) ? `registeredWithOther: ${values.registeredWithOther}` : "";
  const speciesLatinName = getMultiValueFromTypeAhead(values.speciesLatinName, values.speciesLatinNameSelect, "speciesLatinName", "speciesLatinNameSearchType");
  const includeSynonyms = (speciesLatinName.length > 0 && values.includeSynonyms)?`includeSynonyms:"1"`:"";
  const countries = getValueFromMultiselect(values.countries, 'countryid');
  const denominationNature = getValueFromMultiselect(values.denominationNature, 'denominationNature');
  const varietyStatusParams = getValueFromMultiselect(values.varietyStatus, 'varietyStatus');
  const registerType =  getValueFromMultiselect(values.registerType, 'registerType');
  const breedersReference = getValueFromFormControl(values.breedersReference, values.breedersReferenceSelect, "breedersReference", "breedersReferenceSearchType", /[ -/]/g);
  const breedersName  = getSingleValueFromTypeAhead(values.breedersName, values.breedersNameSelect, "breederName", "breederNameSearchType");

  const parties  = getSingleValueFromTypeAhead(values.parties, values.partiesSelect, "otherParty", "otherPartySearchType");
  const applicationNumber = getSingleValueFromTypeAhead(values.applicationNumber, values.applicationNumberSelect, "applicationNumber", "applicationNumberSearchType");
  const grantRegistrationNumber = getSingleValueFromTypeAhead(values.grantRegistrationNumber, values.grantRegistrationNumberSelect, "grantNumber", "grantNumberSearchType");
  const speciesClassCode = values.speciesClassCodeSelect === selectOptions.EXACT ?
                                  getMultiValueFromTypeAhead(values.speciesClassCode, values.speciesClassCodeSelect, "speciesClassCode", "speciesClassCodeSearchType")
                                : getValueFromFormControl(values.speciesClassCode, values.speciesClassCodeSelect, "speciesClassCode",  "speciesClassCodeSearchType");
  const speciesClassName = values.speciesClassNameSelect === selectOptions.EXACT ?
                                  getMultiValueFromTypeAhead(values.speciesClassName, values.speciesClassNameSelect, "speciesClass", "speciesClassSearchType")
                                : getValueFromFormControl(values.speciesClassName, values.speciesClassNameSelect, "speciesClass",  "speciesClassSearchType");
  const applicationDate = getValueFromDate(values.applicationDate, "applicationDate");
  const applicationPubDate = getValueFromDate(values.applicationPubDate, "applicationPublicationDate");
  const grantRegistrationDate = getValueFromDate(values.grantRegistrationDate, "grandRegistrationDate");
  const grantRegistrationPubDate = getValueFromDate(values.grantRegistrationPubDate, "publicationgrandRegistrationDate");
  const renewalDate = getValueFromDate(values.renewalDate, "renewalregistrationDate");
  const varietyInsertionDate = getValueFromDate(values.varietyInsertionDate, "varietyInsertDate");
  const denominationInsertionDate = getValueFromDate(values.denominationInsertionDate, "denominationInsertDate");
  const speciesCropSector = getValueFromMultiselect(values.speciesCropSector, 'cropsectors');
  const denominationStatus = getValueFromMultiselect(values.denominationStatus, 'denominationStatus');
  const registerName = getSingleValueFromTypeAhead(values.registerName, values.registerNameSelect, "registerName", "registerNameSearchType");

  return `
        ${denomination}
        ${registeredWithOther}
        ${includeSynonyms}
        ${speciesLatinName}
        ${countries}
        ${denominationNature}
        ${varietyStatusParams}
        ${registerType}
        ${breedersReference}
        ${breedersName}
        ${parties}
        ${applicationNumber}
        ${applicationDate}
        ${applicationPubDate}
        ${grantRegistrationNumber}
        ${grantRegistrationDate}
        ${grantRegistrationPubDate}
        ${renewalDate}
        ${varietyInsertionDate}
        ${denominationInsertionDate}
        ${speciesClassCode}
        ${speciesClassName}
        ${denominationStatus}
        ${speciesCropSector}
        ${registerName}
  `;
}

export const getDataSheetFromVidQuery = (varietyIds: string[]) => {
  return {
    query: `
    {
      datasheetFromVid(
        varietyids:${JSON.stringify(varietyIds)}
      ){
        applicationnumber
        applicant
        app_date
        app_pub_date
        breeder
        breeder_ref
        country
        countryid
        crop_sectors
        end_date
        extra_data_url
        future_exp_date
        grant_date
        grant_number
        grant_pub_date
        maintainer
        name
        other_names
        other_parties
        pub_name
        pub_type_name
        publicationtypeid
        publicationextraid
        remark
        reg_status
        renewal_date
        species_code
        species_classes
        species_princ_bot_name
        titleholder
        varietyid
        websiteurl
        denominationsList
      }
    }`
  };
}

export const getVarietyDataSheetQuery = (varietyid: string) => {
  return {
    query: `
    {
      varietyDatasheet(
        varietyid:"${varietyid}"
      ){
        applicationnumber
        applicant
        app_date
        app_pub_date
        breeder
        breeder_ref
        country
        countryid
        crop_sectors
        end_date
        extra_data_url
        future_exp_date
        grant_date
        grant_number
        grant_pub_date
        maintainer
        name
        other_names
        other_parties
        pub_name
        pub_type_name
        publicationtypeid
        publicationextraid
        remark
        reg_status
        renewal_date
        species_code
        species_classes
        species_princ_bot_name
        titleholder
        varietyid
        websiteurl
        denominationsList
      }
    }`
  };
}

export const getSearchQuery = (values: any, pageSize: number, pageIndex: number, sortBy: { id: string, desc: boolean }[], columns: any[], commercial: boolean = false) => {
  const searchParams = createSearchParams(values);
  const sorting = (sortBy && sortBy.length) ? `sortingField:"${sortBy[0].id}" sortingDirection:"${sortBy[0].desc?'desc':'asc'}"`: "";
  const columnsData = columns.filter((val:any) => val.enabled).map((val: any) => val.name).concat(columns.filter((val2: any) => val2.enabled && val2.extraFieldData).map((val2: any) => val2.extraFieldData));

  const mandatoryColumns = [
    searchVarietyReturnTypes.DENOMINATION,
    searchVarietyReturnTypes.COUNTRIES,
    searchVarietyReturnTypes.REGISTER_TYPE,
    searchVarietyReturnTypes.APPLICATION_NUMBER,
    searchVarietyReturnTypes.PUBLICATION_EXTRA_ID,
    searchVarietyReturnTypes.VARIETY_ID
  ].filter((val : string) => !columnsData.includes(val))

  const searchQuery = `
  {
    ${commercial ? 'searchVarietyCom' : 'searchVariety'}(
      size:${pageSize}
      from:${pageSize*pageIndex}
      ${searchParams}
      ${sorting}
    ){
      data {
        ${searchVarietyReturnTypes.DENOMINATION_SYNONYM},
        ${searchVarietyReturnTypes.REGISTER},
        ${columnsData.concat(mandatoryColumns).join(",")}
      }
      total
    }
  }`

  return {
    query: gqlPrettier(searchQuery)
  };
}

export const getSearchCountQuery = (values: any) => {
  const searchParams = createSearchParams(values);

  const searchQuery = `
    {
      count(
        size:1
        ${searchParams}
      )
    }`

  return {
    query: gqlPrettier(searchQuery)
  };
}

const createSearchSpeciesParams = (values: any) => {
  const speciesLatinName = getSingleValueFromTypeAhead(values.speciesLatinName, values.speciesLatinNameSelect, "speciesLatinName", "speciesLatinNameSearchType");
  const speciesCode = getValueFromFormControl(values.speciesCode, values.speciesCodeSelect, "speciesCode", "speciesCodeSearchType");
  const commonName = getValueFromFormControl(values.commonName, values.commonNameSelect, "commonName", "commonNameSearchType");
  const commonNameLanguage = getValueFromMultiselect(values.commonNameLanguage, 'commonNameLanguage');
  const cropSector = getValueFromMultiselect(values.speciesCropSector, 'cropSector');

  return `
        ${speciesLatinName}
        ${speciesCode}
        ${commonName}
        ${commonNameLanguage}
        ${cropSector}
  `;
}


export const getSearchSpeciesQuery = (values: any, pageSize: number, pageIndex: number) => {
  const searchParams = createSearchSpeciesParams(values);

  const searchQuery = `
    {
      speciesSearch(
        size:${pageSize}
        from:${pageSize*pageIndex}
        ${searchParams}
      ){
        total
        data {
          class_data {
            class_id
            class_type
            class_name
            class_type_value
          }
          species_id
          crop_sectors
          princ_bot
          other_bot
          comments
          species_upov
          en
          fr
          de
          es
        }
      }
    }`

  return {
    query: gqlPrettier(searchQuery)
  };
}

const createSearchClassesParams = (values: any) => {
  const classCode = getSingleValueFromTypeAhead(values.classCode, values.classCodeSelect, "classid", "classidSearchType");
  const className = getValueFromFormControl(values.className, values.classNameSelect, "classname", "classnameSearchType");

  return `
        ${classCode}
        ${className}
  `;
}


export const getSearchClassesQuery = (values: any, pageSize: number, pageIndex: number) => {
  const searchParams = createSearchClassesParams(values);

  const searchQuery = `
  {
    classesSearch(
      size:${pageSize}
      from:${pageSize*pageIndex}
      ${searchParams}
    ){
      total
      data {
        classid,
        upovclass,
        classname,
        species_object,
        info
      }
    }
  }`

  return {
    query: gqlPrettier(searchQuery)
  };
}

export const getSpeciesSearchByID = (values: any) => {
  return {
    query: `
    {
      speciesSearchByID(
        specieId: ${JSON.stringify(values)}
      ) {
        princ_bot,
        species_id
      }
    }`
  }
}

const createRegistersParams = (values: any) => {
  const country =  getValueFromFormControlSelect(values.countryid, registersFields.COUNTRY);
  const registerType =  getValueFromFormControlSelect(values.registerType, registersFields.REGISTER);
  const extraid = (values?.extraid!==undefined && values?.extraid!==null)?(`extraid:"${values?.extraid}"`):"";

  return `
    ${country}
    ${registerType}
    ${extraid}
  `;
}

export const getRegistersQuery = (values: any, pageSize: number, pageIndex: number, sortBy?: { id: string, desc: boolean }[]) => {
  const searchParams = createRegistersParams(values);
  const sorting = (sortBy && sortBy.length) ? `sortingField:"${sortBy[0].id}" sortingDirection:"${sortBy[0].desc?'desc':'asc'}"`: "";

  const searchQuery = `
  {
    registersSearch(
      size:${pageSize}
      from:${pageSize*pageIndex}
      ${searchParams}
      ${sorting}
    ){
      total
      data {
        countryid
        publicationtypeid
        publicationname
        name
        addressformatted
        websiteurl
        remarks
        email
        all_contributions {
            pub_date
            pub_number
            pub_info
        }
      }
    }
  }`

  return {
    query: gqlPrettier(searchQuery)
  };
}

const createSearchJurisprudenceParams = (values: any) => {
  const article =  getValueFromFormControlSelect(values.article, "article");
  const subheading =  getValueFromFormControlSelect(values.subheading, "subHeading");
  const outcome =  getValueFromFormControlSelect(values.outcome, "outcome");
  const denomination = getValueFromFormControl(values.denomination, "", "denomination",  "");
  const keyword = getValueFromFormControl(values.keyword, "", "decisionKwrd",  "");
  const decisionDate = getValueFromDecisionDate(values.decisionDate, "decisionDate");

  return `
        ${article}
        ${subheading}
        ${outcome}
        ${denomination}
        ${keyword}
        ${decisionDate}
  `;
}

export const getSearchJurisprudenceQuery = (values: any, pageSize: number, pageIndex: number) => {
  const searchParams = createSearchJurisprudenceParams(values);

  const searchQuery = `
  {
    jurisprudenceSearch(
      size:${pageSize}
      from:${pageSize*pageIndex}
      ${searchParams}
    ){
      data {
        ${jurisprudenceReturnTypes.ID}
        ${jurisprudenceReturnTypes.ARTICLE}
        ${jurisprudenceReturnTypes.SUBHEADING}
        ${jurisprudenceReturnTypes.SPECIES_NAME}
        ${jurisprudenceReturnTypes.TITLE}
        ${jurisprudenceReturnTypes.DENOMINATION}
        ${jurisprudenceReturnTypes.DECISION_DATE}
        ${jurisprudenceReturnTypes.OUTCOME}
        ${jurisprudenceReturnTypes.DESCRIPTION}
       } total
    }
  }`

  return {
    query: gqlPrettier(searchQuery)
  };
}

export const createTestDenominationFromValues = (values: any, sendQuery = true) => {
  const denomination = getValueFromFormControlObj(values.denomination, "", testDenominationFields.DENOMINATION,  "", null, false);
  const speciesLatinName = getSingleValueFromTypeAheadObj(values.speciesLatinName, "", testDenominationFields.SPECIES_LATIN_NAME,  "", "", false);
  const specieId = getSingleValueFromTypeAheadObj(values.speciesLatinName, "", testDenominationFields.SPECIES_ID,  "", "specieid", false);
  const breedersReference = getValueFromFormControlObj(values.breedersReference, "", testDenominationFields.BREEDERS_REFERENCE,  "", null, false);
  const breedersName = getValueFromFormControlObj(values.breedersName, "", testDenominationFields.BREEDERS_NAME,  "", null, false);
  const batchName = getValueFromFormControlObj(values.batchName, "", testDenominationFields.BATCH_NAME,  "", null, false);
  const additionalInformation = getValueFromFormControlObj(values.additionalInformation, "", testDenominationFields.ADDITIONAL_INFORMATION,  "", null, false);
  const requestAdvice = values.requestAdvice?[{[testDenominationFields.REQUEST_ADVICE] : '1'}]:[];

  return Object.assign(
    {},
    ...denomination,
    ...specieId,
    ...speciesLatinName,
    ...breedersReference,
    ...breedersName,
    ...batchName,
    ...additionalInformation,
    ...requestAdvice
  )
}

export const createAlertFromValues = (values:any, sendQuery = true) => {
  const objectName = getValueFromFormControlObj(values.denomination, "", alertFields.DENOMINATION, "", null, false);
  const startDate = getValueFromFormControlObj(values.testDate[0].value, "", alertFields.START_DATE, "", null, false);
  const endDate = getValueFromFormControlObj(values.testDate[1]?.value?(values.testDate[1].value):"", "", alertFields.END_DATE, "", null, false);
  const conditions = [
    {
      "sub_countries": values.countries?.length ?
                                (values.countries.filter((item: { value: string; }) => !["EU", "NON-EU"].includes(JSON.parse(item.value)?.countryid))
                                                .map((item: { value: string; }) => JSON.parse(item.value)?.countryid))
                              : [""],
      "sub_species": values.speciesLatinName?.length ? (values.speciesLatinName.map((item: { specieid: any; }) => item.specieid)) : [""]
    }
  ];

  return Object.assign(
    {},
    ...objectName,
    ...startDate,
    ...endDate,
    {conditions: conditions}
  )
}

export const createSubscriptionFromValues = (values:any, sendQuery = true) => {
  const country =  getValueFromFormControlSelectObj(values.countryid, "country_id");
  const filename =  getValueFromFormControlObj(values.filename, "", "file_name", "");

  return Object.assign(
    {},
    country,
    ...filename,
    {comment: values.comment}
  );
}

export const getRequestAccessQuery = (values: any) => {
  return {
    reason: getValueFromFormControlObj(values.additionalInformation, "", testDenominationFields.ADDITIONAL_INFORMATION,  "", null, false)
  }
}

export const getSubmitTestQuery = (values: any) => {
  return {
    tests: [
      createTestDenominationFromValues(values)
    ]
  }
}

export const getSubmitMultipleTestsQuery = (values: any) => {
  const retValues = JSON.parse(JSON.stringify(values));
  return {
    tests: retValues.map((value: any) => {
      delete value.error;
      delete value.species_latin_name;
      return value;
    })
  }
}

export const getCheckInputQuery = (values: any) => {
  return {
    payload: values
  }
}


export const getViewTestsQuery = (values: any, refreshAll = false) => {
  const pending = refreshAll?values:values.filter((item: any) => item[testDenominationFields.TEST_STATUS] === testDenominationStatus.PENDING);
  return {
      "test_ids": pending.map((item: any) => item.test_id)
  }
}

export const getMyTestsQuery = (values: any, pageSize: number, pageIndex: number, sortBy: { id: string, desc: boolean }[]) => {
  const expertAdviceObj = getValueFromMultiselectObj(values.expertAdvice, 'advice');
  const expertAdvice = expertAdviceObj.length ? expertAdviceObj[0] : []

  const testDateObj = getValueFromDateObj(values.testDate, "testDate");
  const testDate = { test_dt_from: "", test_dt_to: "" };

  const getSortById = (id: string) => {
    if (id === myTestsReturnTypes.REQUEST_ADVICE_ID) {
      return myTestsReturnTypes.ADVICE.toUpperCase();
    } else if (id === myTestsReturnTypes.BREEDER_REFERENCE) {
      return "BRED_REF";
    } else {
      return id.toUpperCase();
    }
  }

  const sorting = (sortBy && sortBy.length) ? {sort_column: getSortById(sortBy[0].id), sort_order: sortBy[0].desc?"DESC":"ASC"}: {} ;

  testDateObj.forEach((date: any) => {
    if (date.testDateFrom) {
      testDate.test_dt_from = date.testDateFrom;
    } else if (date.testDateTo) {
      testDate.test_dt_to = date.testDateTo;
    }
  });

  const output = {
      ...expertAdvice,
      ...testDate,
      ...sorting,
      "deno_name": values.denomination,
      "deno_search" : 0,
      "batch_name": values.batchName,
      "batch_search" : 0,
      "species_name": values.speciesLatinName,
      "species_search" : 0,
      "org_id" : values.testsOrganization?1:0,
      "tests_archived" : values.archivedTests?1:0,
      "fetch_size" : pageSize,
      "fetch_offset" : pageSize*pageIndex
    };

    return JSON.stringify(output);
}

const escapeValue = (txt: string) => {
  return txt
    .replace(".", "\\.");
};

const createSearchParamsObj = (values: any) => {
  const denomination = getValueFromFormControlObj(values.denomination, values.denominationSelect, "denomination",  "denominationSearchType");
  const speciesLatinName = getMultiValueFromTypeAheadObj(values.speciesLatinName, values.speciesLatinNameSelect, "speciesLatinName", "speciesLatinNameSearchType");
  const includeSynonyms = (speciesLatinName.length > 0 && values.includeSynonyms)?[{'includeSynonyms' : '1'}]:[];
  const registeredWithOther = ["0", "1"].includes(values.registeredWithOther) ? [{'registeredWithOther' : parseInt(values.registeredWithOther)}] : [];
  const countries = getValueFromMultiselectObj(values.countries, 'countryid');
  const denominationNature = getValueFromMultiselectObj(values.denominationNature, 'denominationNature');
  const varietyStatusObj = getValueFromMultiselectObj(values.varietyStatus, 'varietyStatus');
  const registerType =  getValueFromMultiselectObj(values.registerType, 'registerType');
  const breedersReference = getValueFromFormControlObj(escapeValue(values.breedersReference), values.breedersReferenceSelect, "breedersReference", "breedersReferenceSearchType",  /[ -/]/g);
  const breedersName  = getSingleValueFromTypeAheadObj(values.breedersName, values.breedersNameSelect, "breederName", "breederNameSearchType");
  const parties  = getSingleValueFromTypeAheadObj(values.parties, values.partiesSelect, "otherParty", "otherPartySearchType");
  const applicationNumber = getSingleValueFromTypeAheadObj(values.applicationNumber, values.applicationNumberSelect, "applicationNumber", "applicationNumberSearchType");
  const grantRegistrationNumber = getSingleValueFromTypeAheadObj(values.grantRegistrationNumber, values.grantRegistrationNumberSelect, "grantNumber", "grantNumberSearchType");
  const speciesClassCode = values.speciesClassCodeSelect === selectOptions.EXACT ?
                              getMultiValueFromTypeAheadObj(values.speciesClassCode, values.speciesClassCodeSelect, "speciesClassCode", "speciesClassCodeSearchType")
                            : getValueFromFormControlObj(values.speciesClassCode, values.speciesClassCodeSelect, "speciesClassCode",  "speciesClassCodeSearchType");
  const speciesClassName = values.speciesClassNameSelect === selectOptions.EXACT ?
                              getMultiValueFromTypeAheadObj(values.speciesClassName, values.speciesClassNameSelect, "speciesClass", "speciesClassSearchType")
                            : getValueFromFormControlObj(values.speciesClassName, values.speciesClassNameSelect, "speciesClass",  "speciesClassSearchType");
  const applicationDate = getValueFromDateObj(values.applicationDate, "applicationDate");
  const applicationPubDate = getValueFromDateObj(values.applicationPubDate, "applicationPublicationDate");
  const grantRegistrationDate = getValueFromDateObj(values.grantRegistrationDate, "grandRegistrationDate");
  const grantRegistrationPubDate = getValueFromDateObj(values.grantRegistrationPubDate, "publicationgrandRegistrationDate");
  const renewalDate = getValueFromDateObj(values.renewalDate, "renewalregistrationDate");
  const varietyInsertionDate = getValueFromDateObj(values.varietyInsertionDate, "varietyInsertDate");
  const denominationInsertionDate = getValueFromDateObj(values.denominationInsertionDate, "denominationInsertDate");
  const speciesCropSector = getValueFromMultiselectObj(values.speciesCropSector, 'cropsectors');
  const denominationStatus = getValueFromMultiselectObj(values.denominationStatus, 'denominationStatus');
  const registerName = getSingleValueFromTypeAheadObj(values.registerName, values.registerNameSelect, "register_name", "registerNameSearchType");

  return [
    ...denomination,
    ...registeredWithOther,
    ...speciesLatinName,
    ...includeSynonyms,
    ...countries,
    ...denominationNature,
    ...varietyStatusObj,
    ...registerType,
    ...breedersReference,
    ...breedersName,
    ...parties,
    ...applicationNumber,
    ...applicationDate,
    ...applicationPubDate,
    ...grantRegistrationNumber,
    ...grantRegistrationDate,
    ...grantRegistrationPubDate,
    ...renewalDate,
    ...varietyInsertionDate,
    ...denominationInsertionDate,
    ...speciesClassCode,
    ...speciesClassName,
    ...denominationStatus,
    ...speciesCropSector,
    ...registerName
  ];
}

export const getExportNoteQuery = (values: any) => {
  const searchParams:any = createSearchParamsObj(values);

  const output = {
      searchQuery:  {
        fields: searchParams,
        terms: [
          "key",
          "doc_count"
        ]
      }
    };

    return JSON.stringify(output);
}

export const getDownloadExcelQuery = (values: any, sortBy: { id: string, desc: boolean }[], columns: any) => {
  const searchParams:any = createSearchParamsObj(values);

  const columnsData = columns.filter((val:any) => val.enabled).map((val: any) => val.name);

  const output = {
    searchQuery:  {
        fields: [{
          "size": 0
        },
        ...searchParams
      ],
      terms: columnsData
    }
  };

  return JSON.stringify(output);
}

export interface DObject {
  [key: string]: string | number
}

const getValueFromMultiselectObj = (value: any, elasticField: string) => {
  const output: DObject[] = [];
  const obj: DObject = {};
  if (value && value.length > 0) {
    obj[elasticField] = value.map((el: any) => {
      if (typeof(el.value) === 'number') {
        return el.value;
      }
      try {
        const parsedValue = JSON.parse(el.value);
        return parsedValue.countryid.toLowerCase();
      } catch {
        return el.value.toLowerCase();
      }
    });
    output.push(obj);
  }
  return output;
}

const getMultiValueFromTypeAheadObj = (value: any, valueSelect: string, elasticField: string, elasticFieldSearchType: string) => {
  const output: DObject[] = [];
  let obj: DObject = {};
  if (value && value.length > 0) {
    obj[elasticField] = value.map((el: any) => el.value.toLowerCase());
    output.push(obj);
    obj = {};
    obj[elasticFieldSearchType] = valueSelect;
    output.push(obj);
  }
  return output;
}

const getSingleValueFromTypeAheadObj = (value: any, valueSelect: string, elasticField: string, elasticFieldSearchType: string, valueField = "", forceLowercase = true) => {
  const output: DObject[] = [];
  let obj: DObject = {};
  if (value && value.length > 0) {
    const returnValue = valueField && value[0][valueField]?value[0][valueField]:value[0].value;
    obj[elasticField] = forceLowercase?returnValue.toLowerCase():returnValue;
    output.push(obj);
    obj = {}
    if (valueSelect) {
      obj[elasticFieldSearchType] = valueSelect;
      output.push(obj);
    }
  }
  return output;
}


const getValueFromFormControlObj = (value: any, valueSelect: string, elasticField: string, elasticFieldSearchType: string, regexp: RegExp|null = null, forceLowercase = true) => {
  const output: DObject[] = [];
  let obj: DObject = {};
  if (value && value.length > 0) {
    const newValue = forceLowercase?value.toLowerCase():value;
    obj[elasticField] = (regexp)?newValue.replace(regexp, ""):newValue;
    output.push(obj);
    obj = {}
    if (valueSelect) {
      obj[elasticFieldSearchType] = valueSelect;
      output.push(obj);
    }
  }
  return output;
}

const getValueFromDateObj = (date: any, elasticField: string) => {
  const output: DObject[] = [];
  let obj: DObject = {};
  if (date && date.length > 0) {
    date.forEach(function(el: any) {
      if (el.value) {
        const elasticFieldType = (el.type) ? el.type.charAt(0).toUpperCase() + el.type.slice(1) : '';
        obj[elasticField+elasticFieldType] = parseInt(el.value);
        output.push(obj);
        obj = {}
      }
    });
  }
  return output;
}

const getValueFromMultiselect = (value: any, elasticField: string) => {
  return (value && value.length > 0) ? `${elasticField}:${JSON.stringify(value.map((el: any) => {
    if (typeof el.value === 'number') {
      return el.value;
    }
    try {
      const parsedValue = JSON.parse(el.value);
      return parsedValue.countryid.toLowerCase();
    } catch {
     return el.value.toLowerCase();
    }
  }))}` : '';
}

const getMultiValueFromTypeAhead = (value: any, valueSelect: string, elasticField: string, elasticFieldSearchType: string) => {
  return (value && value.length > 0) ? `${elasticField}:${JSON.stringify(value.map((el: any) => el.value.toLowerCase()))} ${elasticFieldSearchType}:"${valueSelect}"` : '';
}

const getSingleValueFromTypeAhead = (value: any, valueSelect: string, elasticField: string, elasticFieldSearchType: string) => {
  return (value && value.length > 0 && Array.isArray(value)) ? `${elasticField}:"${value[0].value.toLowerCase()}" ${elasticFieldSearchType}:"${valueSelect}"` : '';
}

const getValueFromFormControl = (value: any, valueSelect: string, elasticField: string, elasticFieldSearchType: string, regexp: RegExp|null = null) => {
  if (value && value.length > 0) {
    const val = (regexp)?value.replace(regexp,""):value;
    const searchType = elasticFieldSearchType ? `${elasticFieldSearchType}:"${valueSelect}"` : "";
    return `${elasticField}:"${val.toLowerCase()}" ${searchType}`
  } else {
    return "";
  }
}

const getValueFromFormControlSelect = (value: any, elasticField: string) => {
  return (value)?`${elasticField}:"${value.toLowerCase()}"`:""
}

const getValueFromFormControlSelectObj = (value: any, elasticField: string) => {
  const obj: DObject = {};
  if (value) {
    obj[elasticField] = value.toLowerCase();
  }
  return obj;
}

const getValueFromDate = (date: any, elasticField: string) => {
  let output = '';
  if (date && date.length > 0) {
    date.forEach(function(el: any) {
      const elasticFieldType = (el.type) ? el.type.charAt(0).toUpperCase() + el.type.slice(1) : '';
      output += (el.value) ? ` ${elasticField}${elasticFieldType}:${el.value}` : '';
    });
  }

  return output;
}

const getValueFromDecisionDate = (date: any, elasticField: string) => {
  let output = '';

  const getFieldTypeName = (type: string) => {
    switch (type) {
      case 'from':
        return 'Min';
      case 'to':
        return 'Max';
      default:
        return "";
    }
  }

  if (date && date.length > 0) {
    date.forEach(function(el: any) {
      const elasticFieldType = getFieldTypeName(el.type);
      const formattedValue = convertDate(el.value, "DD/MM/YYYY", "YYYYMMDD");
      output += (formattedValue) ? ` ${elasticField}${elasticFieldType}:"${formattedValue}"` : '';
    });
  }

  return output;
}

export const autoCompletePostData = (autoCompleteName: string, term: string, type: string, includeSynonyms = false, autoCompleteReturnString = "") => {
  const synonyms = includeSynonyms?`includeSynonyms:"1"`:"";

  return {
    query: `
    {
      ${autoCompleteName}(
        term: "${term.toLowerCase()}"
        type: "${type}"
        ${synonyms}
      )${autoCompleteReturnString}
    }`
  };
}

export const selectOptions = {
  CONTAINS: 'contains',
  STARTS: 'starts',
  EXACT: 'exact',
  ENDS: 'ends'
}

export const denomNatureOptions = () => {
  return [
    { label: i18n.t('denomination'), value: "denomination" },
    { label: i18n.t('synonym'), value: "synonym" },
    { label: i18n.t('tradename'), value: "trade name" },
    { label: i18n.t('trademark'), value: "trade mark" }
  ];
}

export const varietyStatusOptions = () => {
  return [
    { label: i18n.t('application'), value: 1 },
    { label: i18n.t('registered'), value: 2 },
    { label: i18n.t('withdrawn'), value: 3 },
    { label: i18n.t('rejected'), value: 4 },
    { label: i18n.t('surrendered'), value: 5 },
    { label: i18n.t('terminated'), value: 6 },
    { label: i18n.t('expired'), value: 7 }
 ];
}

export const registerTypeOptions = ( includeRef = false ) => {
  const options = [
    { label: i18n.t("register_types.pbr"), value: "pbr" },
    { label: i18n.t("register_types.plp"), value: "plp" },
    { label: i18n.t("register_types.eutm"), value: "eutm" },
    { label: i18n.t("register_types.nli"), value: "nli" },
    { label: i18n.t("register_types.fru"), value: "fru" },
    { label: i18n.t("register_types.com"), value: "com" },
    { label: i18n.t("register_types.zzz"), value: "zzz" },
    { label: i18n.t("register_types.ref"), value: "ref" },
    { label: i18n.t("register_types.pgr"), value: "pgr" }
  ]

  return (includeRef)?(options):(options.slice(0,-1))
}

export const speciesCropSectorOptions = () => {
  return [
    { label: i18n.t("agricultural"), value: "agricultural" },
    { label: i18n.t("vegetable"), value: "vegetable" },
    { label: i18n.t("fruit"), value: "fruit" },
    { label: i18n.t("ornamental"), value: "ornamental" },
    { label: i18n.t("forest"), value: "forest" },
    { label: i18n.t("miscellaneous"), value: "miscellaneous" },
  ];
}

export const commonNameLanguageOptions = () => {
  return [
    { label: i18n.t("languages.en"), value: "en" },
    { label: i18n.t("languages.fr"), value: "fr" },
    { label: i18n.t("languages.de"), value: "de" },
    { label: i18n.t("languages.es"), value: "es" },
    { label: i18n.t("languages.latin"), value: "other_bot" },
  ];
}

export const denominationStatusOptions = () => {
  return [
    { label: i18n.t('proposed'), value: 'proposed' },
    { label: i18n.t('published'), value: 'published' },
    { label: i18n.t('approved'), value: 'approved' },
    { label: i18n.t('rejected_withdrawn'), value: 'rejected' },
    { label: i18n.t('cancelled'), value: 'cancelled' },
  ];
}

export const speciesLatinNameSelectOptions = () => {
  return [
    { value: i18n.t(selectOptions.CONTAINS), key: selectOptions.CONTAINS, default: true} ,
    { value: i18n.t(selectOptions.STARTS), key: selectOptions.STARTS },
    { value: i18n.t(selectOptions.EXACT), key: selectOptions.EXACT },
    { value: i18n.t(selectOptions.ENDS), key: selectOptions.ENDS },
  ];
}

export const breedersReferenceSelectOptions = () => {
  return [
    { value: i18n.t(selectOptions.CONTAINS), key: selectOptions.CONTAINS, default: true },
    { value: i18n.t(selectOptions.EXACT), key: selectOptions.EXACT },
  ];
}

export const denominationSelectOptions = () => {
  return [
    { value: i18n.t(selectOptions.CONTAINS), key: selectOptions.CONTAINS },
    { value: i18n.t(selectOptions.STARTS), key: selectOptions.STARTS, default: true },
    { value: i18n.t(selectOptions.EXACT), key: selectOptions.EXACT },
    { value: i18n.t(selectOptions.ENDS), key: selectOptions.ENDS },
  ];
}

export const breederNameSelectOptions = () => {
  return [
    { value: i18n.t(selectOptions.CONTAINS), key: selectOptions.CONTAINS, default: true },
    { value: i18n.t(selectOptions.EXACT), key: selectOptions.EXACT },
  ];
}

export const partiesSelectOptions = () => {
  return [
    { value: i18n.t(selectOptions.CONTAINS), key: selectOptions.CONTAINS, default: true },
    { value: i18n.t(selectOptions.EXACT), key: selectOptions.EXACT },
  ];
}

export const applicationNumberSelectOptions = () => {
  return [
    { value: i18n.t(selectOptions.STARTS), key: selectOptions.STARTS },
    { value: i18n.t(selectOptions.CONTAINS), key: selectOptions.CONTAINS },
    { value: i18n.t(selectOptions.EXACT), key: selectOptions.EXACT, default: true },
  ];
}

export const speciesClassCodeSelectOptions = () => {
  return [
    { value: i18n.t(selectOptions.STARTS), key: selectOptions.STARTS, default: true },
    { value: i18n.t(selectOptions.CONTAINS), key: selectOptions.CONTAINS },
    { value: i18n.t(selectOptions.EXACT), key: selectOptions.EXACT },
  ];
}

export const upovClassCodeSelectOptions = () => {
  return [
    { value: i18n.t(selectOptions.STARTS), key: selectOptions.STARTS },
    { value: i18n.t(selectOptions.EXACT), key: selectOptions.EXACT, default: true },
  ];
}

export const speciesClassNameSelectOptions = () => {
  return [
    { value: i18n.t(selectOptions.STARTS), key: selectOptions.STARTS, default: true },
    { value: i18n.t(selectOptions.CONTAINS), key: selectOptions.CONTAINS },
    { value: i18n.t(selectOptions.EXACT), key: selectOptions.EXACT },
  ];
}

export const registerNameSelectOptions = () => {
  return [
    { value: i18n.t(selectOptions.STARTS), key: selectOptions.STARTS },
    { value: i18n.t(selectOptions.CONTAINS), key: selectOptions.CONTAINS },
    { value: i18n.t(selectOptions.EXACT), key: selectOptions.EXACT, default: true },
  ];
}

export const validDenominationOptions = () => {
  return [
    { label: i18n.t("all"), value: ""},
    { label: i18n.t("valid"), value: "0"},
    { label: i18n.t("invalid"), value: "1"}
  ]
}

export const getCookieToken = () => {
  return Cookies.get(process.env.REACT_APP_COOKIE_KEY!);
}

export const NO_COOKIE_ERROR = "NO_COOKIE_FOUND_ERROR";
export const NO_COOKIE_REDIRECT = "NO_COOKIE_REDIRECT";

export const getToken = () => {
  const sessionToken = sessionStorage.getItem(process.env.REACT_APP_COOKIE_KEY!);
  return sessionToken?sessionToken:"";
}

export const checkTokenError = (token: string) => {
  return token === NO_COOKIE_ERROR || token === NO_COOKIE_REDIRECT;
}

export const getCpvoStats = () => {
  const sessionStats = sessionStorage.getItem("cpvo_stats");
  if (sessionStats) {
    try {
      return JSON.parse(sessionStats);
    } catch { }
  }
  return {};
}

export const searchVarietyReturnTypes = {
  DENOMINATION: 'denomination',
  SPECIES_LATIN_NAME: 'specielatinname',
  COUNTRIES: 'countryid',
  COUNTRY_NAME: 'countryname',
  DENOMINATION_NATURE: 'denominationnature',
  VARIETY_STATUS: 'varietystatus',
  VARIETY_STATUS_TEXT: 'applicationstatus',
  REGISTER_TYPE_NAME: 'registertypename',
  REGISTER_TYPE: 'publicationtype',
  BREEDERS_REFERENCE: 'breederreference',
  BREEDERS_NAME: 'breedername',
  SPECIES_CROP_SECTOR: 'cropsectors',
  OTHER_PARTIES: 'otherparty',
  APPLICATION_NUMBER: 'applicationnumber',
  APPLICATION_DATE: 'applicationdate',
  APPLICATION_PUB_DATE: 'pubapplicationdate',
  GRANT_REGISTRATION_NUMBER: 'grantnumber',
  GRANT_REGISTRATION_DATE: 'grantdate',
  GRANT_REGISTRATION_PUB_DATE: 'pubgrantdate',
  RENEWAL_DATE: 'renewalregistration',
  REGISTER: 'register',
  VARIETY_INSERTION_DATE: 'varietyinsertdate',
  DENOMINATION_INSERTION_DATE: 'denominationinsertdate',
  SPECIES_CLASS_CODE: 'specieclasscodes',
  SPECIES_CLASS_NAME: 'specieclasses',
  DENOMINATION_STATUS: 'denominationstatus',
  EU_MEMBER: 'iseumember',
  DENOMINATION_SYNONYM: 'registeredwithother',
  PUBLICATION_EXTRA_ID: 'publicationextraid',
  VARIETY_ID: 'varietyid',
  APPLICANT: 'applicantname',
  HOLDER: 'holdername',
  MAINTAINER: 'maintainername',
  EXPIRATION_ACTUAL: 'enddate',
  FUTURE_EXPIRATION_DATE: 'futureexpirationdate',
  DENOMINATION_TYPE: 'denominationtype',
  DENOMINATION_PROPOSAL_DATE: 'proposaldate',
  DENOMINATION_APPROVAL_DATE: 'approvaldate',
  DENOMINATION_PUBLISHED_DATE: 'pubproposaldate',
  REMARKS: 'remark',
  SPECIES_CODE: 'speciesid',
  DENOMINATION_END_DATE: 'deno_end_date',
  SPECIES_NAME_EN: 'species_name_en',
  EXTRA_DATA_URL: 'extra_data_url',
  REGISTER_NAME: 'register_name'
  /* UNUSED-UNKNOWN RETURN TYPES
  COMMON_IDENTIFIER: 'upovcommonidentifier',
  PUBLICATION_PROPOSAL_DATE: 'pubproposaldate',
  EU_MEMBER: 'eu_member',
  DENOMINATION_SYNONYM: 'deno_synonym',
  DENOMINATION_ID: 'denominationid',
  RENEWAL_REGISTRATION_DATE: 'renewalregistration',
  TRADEMARK: 'tradename',
  */
};

export const searchSpeciesReturnTypes = {
  SPECIES_CODE: 'species_id',
  SPECIES_CLASS: 'class_data',
  CROP_SECTOR: 'crop_sectors',
  PRINCIPAL_BOTANICAL_NAME: 'princ_bot',
  OTHER_BOTANICAL_NAMES: 'other_bot',
  COMMENTS: 'comments',
  COMMON_NAME_EN: 'en',
  COMMON_NAME_FR: 'fr',
  COMMON_NAME_DE: 'de',
  COMMON_NAME_ES: 'es'
}

export const searchClassesReturnTypes = {
  CLASS_CODE: 'classid',
  CLASS: 'upovclass',
  CLASS_NAME: 'classname',
  SPECIES: 'species_object',
  REMARK: 'info'
}

export const registersReturnTypes = {
  COUNTRY: 'countryid',
  REGISTER_TYPE: 'publicationtypeid',
  REGISTER_NAME: 'publicationname',
  ORGANIZATION: 'name',
  ADDRESS: 'addressformatted',
  WEBSITE: 'websiteurl',
  REMARKS: 'remarks',
  EMAIL: 'email',
  LAST_CONTRIBUTION: 'all_contributions',
  LAST_CONTRIBUTION_DATA: 'all_contributions[0].pub_date'
}

export const testDenominationFields = {
  SPECIES_LATIN_NAME: 'species_latin_name',
  SPECIES_ID: 'species_id',
  CLASS_CODE: 'class_code',
  DENOMINATION: 'denomination',
  BREEDERS_REFERENCE: 'breeder_ref',
  BREEDERS_NAME: 'breeder_name',
  BATCH_NAME: 'batch_name',
  ADDITIONAL_INFORMATION: 'user_remark',
  REQUEST_ADVICE: 'analysis_req',
  TEST_STATUS: 'test_status',
  TEST_RESPONSE: 'test_response',
  TEST_DATE: 'test_date',
  REQUEST_ADVICE_ID: 'request_advice_id'
}

export const alertFields = {
  DENOMINATION: 'objectName',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  CONDITIONS: 'conditions'
}

export const registersFields = {
  COUNTRY: 'countryid',
  REGISTER: 'registerType'
}

export const testDenominationStatus = {
  PENDING: -1,
  OK: 0,
  ERROR: 1
}

export const testResultsListReturnTypes = {
  DENOMINATION: 'denomination',
  DENOMINATION_SPECIES: 'denomination_species',
  DENOMINATION_STATUS: 'deno_status',
  BREEDERS_REFERENCE: 'brd_ref',
  BREEDERS_NAME: 'brd_name',
  VARIETY_STATUS: 'var_status',
  DENO_VALID: 'deno_valid',
  VARIETY_STATUS_DATE: 'var_status_date',
  APPLICATION_NUMBER: 'apl_nb',
  SPECIES_LATIN_NAME: 'speciename',
  SCORE: 'score',
  EUTM: 'eutm_tab',
  APPLICANT: 'applicantname',
  TITLE_HOLDER: 'title_holder',
  MAINTAINER: 'maintainer',
  REGISTER: 'register',
  TEST_ID: 'testid'
}

export const myTestsReturnTypes = {
  DENOMINATION: 'denomination',
  ADVICE: 'advice',
  REQUEST_ADVICE_ID: 'request_advice_id',
  BATCH_NAME: 'batch_name',
  CONTACT_NAME: 'contact_name',
  BREEDER_NAME: 'breedername',
  BREEDER_REFERENCE: 'breederreference',
  SPECIES_ID: 'specieid',
  CLASS_CODE: 'class_code',
  SPECIES_LATIN_NAME: 'species_name',
  TEST_DATE: 'test_date',
  TEST_RESPONSE: 'test_response',
  TEST_STATUS: 'test_status',
  TEST_ID: 'testid',
  ADDITIONAL_INFORMATION: 'user_remark',
  TEST_ARCHIVED: 'test_archived',
  USER_INPUT_NEEDED: 'user_input_needed'
};

export const myAlertsReturnTypes = {
  DENOMINATION: 'object_name',
  COUNTRY: 'conditions[0].sub_countries',
  SPECIES_CLASS_CODE: 'conditions[0].sub_species',
  DATE_START: 'data_start',
  DATE_END: 'data_end',
  ALERT_ID: 'id'
}

export const contributionsReturnTypes = {
  COUNTRY: 'country_id',
  DOWNLOAD_READY: 'download_ready',
  FILE_NAME: 'file_name',
  FILE_PATH: 'file_path',
  FILE_SIZE: 'file_size',
  FILE_COMMENT: 'file_comment',
  CONTRIBUTION_ID: 'id',
  UPLOAD_DATE: 'upload_date',
  UPLOADER: 'uploader_name'
}

export const jurisprudenceReturnTypes = {
  ARTICLE: 'article',
  SUBHEADING: 'subheading',
  SPECIES_NAME: 'specieid',
  TITLE: 'title',
  DECISION_DATE: 'decisiondate',
  DENOMINATION: 'denomination',
  OUTCOME: 'outcomestatus',
  DESCRIPTION: 'description',
  ID: 'jurisprudenceid'
}

export const varietyDataSheetRegions = {
  DATA_SHEET: 'openDataSheet',
  NAMES: 'openNames',
  REGISTER: 'openRegionRegister',
  SPECIES: 'openRegionSpecies',
  REGISTRATION_STATUS: 'openRegionRegistrationStatus',
  PARTIES: 'openRegionParties',
  ADDITIONAL_INFO: 'openRegionAdditionalInformation',
}

export const TABLE_SELECT_ROW = "tableCheckbox";

export const TRADE_NAME = "Trade name";
export const TRADE_MARK = "Trade mark";
export const SYNONYM = "Synonym";
export const DENOMINATION = "Denomination";

export const varietyStatus = {
  APPLICATION: 'Application',
  REGISTERED: 'Registered',
  WITHDRAWN: 'Withdrawn',
  REJECTED: 'Rejected',
  SURRENDERED: 'Surrendered',
  TERMINATED: 'Terminated',
  EXPIRED: 'Expired'
}

export const downloadExcelFileNames = {
  SPECIES_CLASS_MODAL: "export.xlsx",
  TEST_DATA_SHEET: "testresults.xlsx",
  MY_TESTS: "MyTests.xlsx",
  REGISTERS: "Registers.xlsx",
  SEARCH_CLASSES: "classes.xlsx",
  SEARCH_SPECIES: "species.xlsx",
  SEARCH_VARIETIES: "report.xlsx",
  SEARCH_JURISPRUDENCE: "export.xlsx"
}

export const downloadExcelWorksheetTitles = {
  SPECIES_CLASS_MODAL_WORKSHEET: "Species code",
  TEST_DATA_SHEET_WORKSHEET: "Test Results",
  MY_TESTS_WORKSHEET: "My Tests",
  REGISTERS_WORKSHEET: "Registers",
  SEARCH_CLASSES_WORKSHEET: "Classes",
  SEARCH_SPECIES_WORKSHEET: "Species",
  SEARCH_VARIETIES_WORKSHEET: "Varieties",
  SEARCH_JURISPRUDENCE_WORKSHEET: "Jurisprudence"
}

export const downloadPdfFileNames = {
  TEST_DATA_SHEET_RESULTS_PDF: "Results-TestDataSheet.pdf",
  TEST_DATA_SHEET_SELECTED_RESULTS_PDF: "SelectedResults.pdf",
  MY_TESTS: "MyTests.pdf",
  VARIETY_DATA_SHEET: "Variety.pdf"
}

export const scrollToRef = (ref: any) => {
  ref.current?.scrollIntoView({behavior: 'smooth'})
}

export const renderTooltipOverlay = ( tooltipContent: any, tooltipIcon: any) => {
  return (tooltipContent ? (
  <OverlayTrigger
    placement="top"
    delay={{ show: 250, hide: 400 }}
    overlay={(props) =>
      <Tooltip id="button-tooltip" {...props}>
        <span dangerouslySetInnerHTML={{__html: tooltipContent}}/>
      </Tooltip>}
    >
    <span className="float-right align-middle inline-block center">
      {tooltipIcon}
    </span>
  </OverlayTrigger>
  ):(<></>)
  )
};

export const searchField = {
  DENOMINATION: 'denomination',
  SPECIES_LATIN_NAME: 'speciesLatinName',
  COUNTRIES: 'countries',
  DENOMINATION_NATURE: 'denominationNature',
  VARIETY_STATUS: 'varietyStatus',
  REGISTER_TYPE: 'registerType',
  BREEDERS_REFERENCE: 'breedersReference',
  BREEDERS_NAME: 'breedersName',
  SPECIES_CROP_SECTOR: 'speciesCropSector',
  PARTIES: 'parties',
  APPLICATION_NUMBER: 'applicationNumber',
  APPLICATION_DATE: 'applicationDate',
  APPLICATION_PUB_DATE: 'applicationPubDate',
  GRANT_REGISTRATION_NUMBER: 'grantRegistrationNumber',
  GRANT_REGISTRATION_DATE: 'grantRegistrationDate',
  GRANT_REGISTRATION_PUB_DATE: 'grantRegistrationPubDate',
  RENEWAL_DATE: 'renewalDate',
  VARIETY_INSERT_DATE: 'varietyInsertionDate',
  DENOMINATION_INSERT_DATE: 'denominationInsertionDate',
  SPECIES_CLASS_CODE: 'speciesClassCode',
  SPECIES_CLASS_NAME: 'speciesClassName',
  DENOMINATION_STATUS: 'denominationStatus',
  REGISTER_NAME: 'registerName',
  VALID_DENOMINATION: 'registeredWithOther'
}

export const searchFieldLabels = {
  [searchField.DENOMINATION]: { nameSelect:'denominationSelect', translation: 'denomination' },
  [searchField.SPECIES_LATIN_NAME]: { nameSelect:'speciesLatinNameSelect', nameCheck: 'includeSynonyms', translation: 'species_latin_name' },
  [searchField.COUNTRIES]: { translation: 'countries' },
  [searchField.DENOMINATION_NATURE]: { translation: 'denomination_nature' },
  [searchField.VARIETY_STATUS]: { translation: 'variety_status' },
  [searchField.REGISTER_TYPE]: { translation: 'register_type' },
  [searchField.BREEDERS_REFERENCE]: { nameSelect:'breedersReferenceSelect', translation: 'breeders_reference' },
  [searchField.BREEDERS_NAME]: { nameSelect:'breedersNameSelect', translation: 'breeders_name' },
  [searchField.SPECIES_CROP_SECTOR]: { translation: 'species_crop_sector' },
  [searchField.PARTIES]: { nameSelect:'partiesSelect', translation: 'other_parties' },
  [searchField.APPLICATION_NUMBER]: { nameSelect:'applicationNumberSelect', translation: 'application_number' },
  [searchField.APPLICATION_DATE]: { translation: 'application_date' },
  [searchField.APPLICATION_PUB_DATE]: { translation: 'application_pub_date' },
  [searchField.GRANT_REGISTRATION_NUMBER]: { nameSelect:'grantRegistrationNumberSelect', translation: 'grant_registration_number' },
  [searchField.GRANT_REGISTRATION_DATE]: { translation: 'grant_registration_date' },
  [searchField.GRANT_REGISTRATION_PUB_DATE]: { translation: 'grant_registration_pub_date' },
  [searchField.RENEWAL_DATE]: { translation: 'renewal_date' },
  [searchField.VARIETY_INSERT_DATE]: { translation: 'variety_insertion_date' },
  [searchField.DENOMINATION_INSERT_DATE]: { translation: 'denomination_insertion_date' },
  [searchField.SPECIES_CLASS_CODE]: { nameSelect:'speciesClassCodeSelect', translation: 'species_code' },
  [searchField.SPECIES_CLASS_NAME]: { nameSelect:'speciesClassNameSelect', translation: 'species_class_name' },
  [searchField.DENOMINATION_STATUS]: { translation: 'denomination_status' },
  [searchField.REGISTER_NAME]: { nameSelect:'registerNameSelect', translation: 'register_name' },
  [searchField.VALID_DENOMINATION]: { translation: 'valid_denomination' }
}

export const updateObject = (oldObject: any, updatedProperties: any) => {
  return {
      ...oldObject,
      ...updatedProperties
  };
};

export const backgroundImages = {
  VARIETIES: 'varieties',
  SPECIES: 'species',
  DENOMINATION: 'denomination',
  MY_TESTS: 'mytests'
}

export const isStandaloneVarietyDatasheet = () => {
  return window.location.pathname.startsWith(`${APP_URLS.SEARCH_VARIETIES}/`);
}

export const getUrlParam = (name: string) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

export const isAdvanced = () => {
  const token: string = getToken();

  if(token) {
    const decoded: any = jwt_decode(token);
    return decoded.roles.includes(process.env.REACT_APP_ADVANCED_USER);
  }

  return false;
}

export const isContributor = () => {
  const token: string = getToken();

  if(token) {
    const decoded: any = jwt_decode(token);
    return decoded.roles.includes(process.env.REACT_APP_CONTRIBUTOR_USER);
  }

  return false;
}

export const isFullSearchExp = () => {
  const token: string = getToken();

  if(token) {
    const decoded: any = jwt_decode(token);
    return decoded.roles.includes(process.env.REACT_APP_FULLSEARCH_USER);
  }

  return false;
}

export const getUserName = () => {
  const token: string = getToken();

  let username = "";
  if (token && !checkTokenError(token)) {
    const decoded: any = jwt_decode(token);
    username = `${decoded.forename} ${decoded.name}`;
  }

  return username;
};

export const getUserId = () => {
  const token: string = getToken();

  let id = "";
  if (token && !checkTokenError(token)) {
    const decoded: any = jwt_decode(token);
    id = decoded.id;
  }

  return id;
};

export const APP_URLS = {
  SEARCH_VARIETIES: '/varieties'
}

export const API_URLS = {
  GRAPHQL: '/graphql',
  EXPORT_NOTE: '/api/v1/exportnote',
  USER_SETTINGS: '/api/v1/users/settings',
  SEARCHES: '/api/v1/users/searches',
  SUBMIT_TESTS: '/api/v1/tests',
  REQUEST_API_ACCESS: '/extended/api/v1/request-api-access',
  TESTS_SEARCH: '/api/v1/tests/search',
  TESTS_ADVICE_REQUEST: '/api/v1/tests/advice/request',
  TESTS_ADVICE_CANCEL: '/api/v1/tests/advice/cancel',
  TESTS_DELETE: '/api/v1/tests/delete',
  TESTS_ARCHIVE: 'api/v1/tests/archive',
  VIEW_TESTS: '/api/v1/tests/fetch-by-ids',
  CHECK_INPUT: '/api/v1/tests/checkinput',
  NOTIFICATIONS: '/api/v1/tests/notifications',
  NOTIFICATIONS_READ_UNREAD: '/api/v1/tests/notifications/read-unread',
  SUBSCRIPTIONS: '/api/v1/subscriptions',
  STATS: '/api/v1/stats',
  CONTRIBUTIONS_LIST: '/api/v1/contributions',
  CONTRIBUTIONS_DOWNLOAD_FILE: '/api/v1/contributions/file',
  CONTRIBUTIONS_COUNTRIES: '/api/v1/contributions/countries',
  DOWNLOAD_DATABASE: '/api/v1/downloaddb'
}

export const GLOBAL_DATE_FORMAT = 'DD/MM/YYYY';
export const GLOBAL_DATETIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';

export const CPVO_EXPERT_ADVICE_STATUS = {
  NOT_REQUESTED: 1,
  REQUESTED: 2,
  PENDING_ANALYSIS: 3,
  PENDING_COMMITTEE: 4,
  NO_OBSERVATION: 5,
  OBSERVATION: 6,
  CANCELLED: 7,
  CONDITION: 8,
  PRIOR_RIGHT: 9,
}

export const CPVO_EXPERT_ADVICE_STATUS_TEXT = {
  NOT_REQUESTED: 'Not requested',
  REQUESTED: 'Requested',
  PENDING_ANALYSIS: 'Pending analysis',
  PENDING_COMMITTEE: 'Pending committee',
  NO_OBSERVATION: 'No observation',
  OBSERVATION: 'observation',
  CANCELLED: 'Cancelled',
  CONDITION: 'Condition',
  PRIOR_RIGHT: 'Prior Right',
}

export const myTestsPageKey = {
  top20: 'top_20',
  top50: 'top_50',
  all: 'all'
};

export const myTestsPdfPageSizeOptions = () => [
  { value: 20, key: myTestsPageKey.top20, label: `${i18n.t('top')} 20`, default: true },
  { value: 50, key: myTestsPageKey.top50, label: `${i18n.t('top')} 50` },
  { value: -1, key: myTestsPageKey.all, label: i18n.t('all') },
];

export const getMyTestsPdfPageSizeData = (key?: any): { size: number, label: string, key: string } => {
  const foundOption = myTestsPdfPageSizeOptions().find((o: any) => key ? o.key === key : o.default);
  return {
    size: foundOption?.value ?? 20,
    label: foundOption?.label ?? `${i18n.t('top')} 20`,
    key: foundOption?.key ?? myTestsPageKey.top20,
  };
};

export const expertAdviceOptions = () => {
  return [
    { label: i18n.t('advice_status.not_requested'), value: CPVO_EXPERT_ADVICE_STATUS.NOT_REQUESTED },
    { label: i18n.t('advice_status.requested'), value: CPVO_EXPERT_ADVICE_STATUS.REQUESTED },
    { label: i18n.t('advice_status.pending_analysis'), value: CPVO_EXPERT_ADVICE_STATUS.PENDING_ANALYSIS },
    { label: i18n.t('advice_status.pending_committee'), value: CPVO_EXPERT_ADVICE_STATUS.PENDING_COMMITTEE },
    { label: i18n.t('advice_status.no_observation'), value: CPVO_EXPERT_ADVICE_STATUS.NO_OBSERVATION },
    { label: i18n.t('advice_status.observation'), value: CPVO_EXPERT_ADVICE_STATUS.OBSERVATION },
    { label: i18n.t('advice_status.cancelled'), value: CPVO_EXPERT_ADVICE_STATUS.CANCELLED },
    { label: i18n.t('advice_status.condition'), value: CPVO_EXPERT_ADVICE_STATUS.CONDITION },
    { label: i18n.t('advice_status.prior_right'), value: CPVO_EXPERT_ADVICE_STATUS.PRIOR_RIGHT },
  ];
}

export const convertDate = (value: any, outputFormat: string = GLOBAL_DATE_FORMAT, inputFormat = "") => {
  if (!value) {
    return "";
  }
  const date = inputFormat?moment(value, inputFormat, true):moment(value);
  return (date.isValid()) ? date.format(outputFormat) : "";
}

export const testDateBefore = (value: IDatePickerValue[]) => {
  const dateFrom = value.find((el: IDatePickerValue) => el.type === "from");
  const dateTo = value.find((el: IDatePickerValue) => el.type === "to");

  if (dateFrom !== undefined && dateTo !== undefined) {
    return moment(dateFrom.value, 'YYYYMMDD', true).isSameOrBefore(moment(dateTo.value, 'YYYYMMDD', true), 'day');
  }

  return true;
}

export const testDateAfter = (value: IDatePickerValue[]) => {
  const dateFrom = value.find((el: IDatePickerValue) => el.type === "from");
  const dateTo = value.find((el: IDatePickerValue) => el.type === "to");

  if (dateFrom !== undefined && dateTo !== undefined) {
    return moment(dateTo.value, 'YYYYMMDD', true).isSameOrAfter(moment(dateFrom.value, 'YYYYMMDD', true), 'day');
  }

  return true;
}

export const testDateFutureDate = (value: IDatePickerValue[]) => {
  const dateFrom = value.find((el: IDatePickerValue) => el.type === "from");
  const dateTo = value.find((el: IDatePickerValue) => el.type === "to");

  const dateTomorrow = moment().add(1,'days');

  let validDateFrom = true;
  let validDateTo = true;

  if (dateFrom !== undefined) {
    validDateFrom = moment(dateFrom.value, 'YYYYMMDD', true).isSameOrAfter(dateTomorrow, 'day');
  }

  if (dateTo !== undefined) {
    validDateTo = moment(dateTo.value, 'YYYYMMDD', true).isSameOrAfter(dateTomorrow, 'day');
  }

  return validDateFrom && validDateTo;
}

export const testDateFromMissing = (value: IDatePickerValue[]) => {
  const dateFrom = value.find((el: IDatePickerValue) => el.type === "from");
  return dateFrom !== undefined
}

export const testDateToMissing = (value: IDatePickerValue[]) => {
  const dateTo = value.find((el: IDatePickerValue) => el.type === "to");
  return dateTo !== undefined
}

export const prefixCheck = (s: any) => {
  if (s && !s.match(/^[a-zA-Z]+:\/\//))
    {
      s = 'https://' + s;
    }
  return s;
}

export const prefixMailto = (email: any) => {
  return (email)?(`mailto:${email}`):""
}

export const overrideStrings = () => {
  return {
    "selectSomeItems": i18n.t("select"),
    "allItemsAreSelected": i18n.t("all_items_selected"),
    "selectAll": i18n.t("all"),
    "search": i18n.t("search")
  }
};

export const checkToday = (timestamp: any) => {
  if (timestamp) {
    const parsedDate = moment(timestamp);
    if (parsedDate.isValid()) {
      return parsedDate.isSame(moment(), 'day');
    }
  }
  return false;
}

export const getErrorTicket = (message: string) => {
  const match = message.match(/^Error_ticket \[([0-9]+?)?\]$/);

  return (match && match.length === 2) ? match[1] : "";
}

export const calcPercentage = (inp: number, totalNum: number) => {
  const percentage = Math.floor(inp/totalNum * 100);
  return (percentage > 100)?100:percentage;
}

export const calcRemaining = (inp: number, totalNum: number) => {
  return (inp > totalNum) ? totalNum : inp;
}

export const downloadBlob = (blob: any, fileName: string) => {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    const url = window.URL.createObjectURL(blob);
    downloadUrl(url, fileName);
  }
}

export const downloadUrl = (url: string, fileName = "") => {
  const link = document.createElement('a');
  link.href = url;
  document.body.appendChild(link);
  if (fileName) {
    link.download = fileName;
  }
  link.click();
  document.body.removeChild(link);
}

export const getCountryNamesFromSession = (countryISO: any) => {
  if (sessionStorage?.countries && countryISO) {
    try {
      return JSON.parse(JSON.parse(sessionStorage.countries)?.find((country: ICountryOption) => JSON.parse(country.value)?.countryid === countryISO)?.value)?.countryname;
    } catch { }
  }
  return "";
}

export const getCountriesFromSession = () => {
  return (sessionStorage?.countries) ? JSON.parse(sessionStorage.countries) : [];
}

export const VARIETY_STATUS_TEXT = {
  APPLICATION: 'Application',
  REGISTERED: 'Registered',
  WITHDRAWN: 'Application withdrawn',
  SURRENDERED: 'Variety surrendered',
  TERMINATED: 'Protection terminated( Cancelled by the relevant authority)',
  EXPIRED: 'Variety expired; Here you receive the strings, not the integers.',
}

export const getVarietyStatusTranslatedText = (text: string) => {
  switch (text) {
    case VARIETY_STATUS_TEXT.APPLICATION:
      return i18n.t('application');
    case VARIETY_STATUS_TEXT.REGISTERED:
      return i18n.t('registered');
    case VARIETY_STATUS_TEXT.WITHDRAWN:
      return i18n.t('withdrawn');
    case VARIETY_STATUS_TEXT.SURRENDERED:
      return i18n.t('surrendered');
    case VARIETY_STATUS_TEXT.TERMINATED:
      return i18n.t('terminated');
    case VARIETY_STATUS_TEXT.EXPIRED:
      return i18n.t('expired');
    default:
      return text;
  }
}

export const getDenominationStatusText = (id: string) => {
  switch (id) {
    case '1':
      return i18n.t('proposed');
    case '2':
      return i18n.t('published');
    case '3':
      return i18n.t('approved');
    case '4':
      return i18n.t('rejected');
    case '5':
      return i18n.t('cancelled');
    default:
      return id;
  }
}

export const LAST_SEARCH_SESSION_KEY = 'lastSearch';
export const COUNTRIES_SESSION_KEY = 'countries';
export const CONTRIBUTION_COUNTRIES_SESSION_KEY = 'contributionCountries';
export const JURISPRUDENCE_SESSION_KEY = 'jurisprudence';

export const getCountries = (setCountriesOptions: any) => {
  const getCountriesPostData = {
    query: `{ Countries{${searchVarietyReturnTypes.EU_MEMBER} ${searchVarietyReturnTypes.COUNTRIES} ${searchVarietyReturnTypes.COUNTRY_NAME}} }`
  };

  graphQLClientInstance.post(API_URLS.GRAPHQL, getCountriesPostData).then((response: any) => {
    const options = (response.data.data.Countries) ? response.data.data.Countries.map((i: any) => ({
      label: `${i.countryname} - ${i.countryid}`,
      value: JSON.stringify(i),
    })): [];
    const euIndex = options.findIndex((item: any) => JSON.parse(item.value)?.countryid === "EU")
    if (euIndex > -1) {
      const euValue = options[euIndex];
      options.splice(euIndex,1);
      options.unshift(euValue);
    } else {
      const euValue = {
        label: "European Union - EU",
        value: JSON.stringify({
          iseumember: 0,
          countryid: "EU",
          countryname: "European Union"
        })
      }
      options.unshift(euValue);
    }

    const cpvoIndex = options.findIndex((item: any) => JSON.parse(item.value)?.countryid === "QZ");
    if (cpvoIndex > -1) {
      const cpvoValue = options[cpvoIndex];
      options.splice(cpvoIndex,1);
      options.splice(1,0,cpvoValue);
    }

    const nonEuValue = {
      label: "Non-EU",
      value: JSON.stringify({
        iseumember: 0,
        countryid: "NON-EU",
        countryname: "Non-EU"
      })
    }
    options.splice(1,0,nonEuValue);

    sessionStorage.setItem(COUNTRIES_SESSION_KEY, JSON.stringify(options));
    setCountriesOptions(options);
  }).catch((err: any) => { console.log(err); } )
}

const checkCountriesDiff = (a: any, b: any) => {
  return a.filter((item: ICountryOption) => !b.find((item2:ICountryOption) => item2.value === item.value));
}

const getCountriesNotSelected = (countries: any[], selected: any[], isEuMember: number) => {
  return countries.filter((item: ICountryOption) =>
    !["EU","NON-EU"].includes(JSON.parse(item.value)?.countryid) &&
    JSON.parse(item.value)?.iseumember === isEuMember &&
    !selected.find((item2: ICountryOption) => item2.value === item.value));
}

const handleCountriesAdd = (changes: any[], newValue: any[], countriesOptions: any[], setFieldValue: any, formKey: any) => {
  const euCountriesNotSelected = getCountriesNotSelected(countriesOptions, newValue, 1);
  const nonEuCountriesNotSelected = getCountriesNotSelected(countriesOptions, newValue, 0);
  const changedValue = JSON.parse(changes[0].value);
  if (changedValue?.countryid === 'EU') {
    // find all eu countries that are not already selected
    setFieldValue(formKey, [...newValue, ...euCountriesNotSelected])
  } else if (changedValue?.countryid === 'NON-EU') {
    setFieldValue(formKey, [...newValue, ...nonEuCountriesNotSelected])
  } else {
    if ((euCountriesNotSelected.length > 0 && changedValue?.iseumember === 1) ||
          (nonEuCountriesNotSelected.length > 0 && changedValue?.iseumember === 0)) {
      setFieldValue(formKey, newValue);
    } else {
      // select EU/NON-EU
      const selector = changedValue?.iseumember === 1 ? "EU" : "NON-EU";
      setFieldValue(formKey, [countriesOptions.find((item: any) => JSON.parse(item.value)?.countryid === selector), ...newValue]);
    }
  }
}

const handleCountriesRemove = (changes: any[], newValue: any[], setFieldValue: any, formKey: any) => {
  if (changes.length > 0) {
    const changedValue = JSON.parse(changes[0].value);
    if (changedValue?.countryid === 'EU') {
      setFieldValue(formKey, newValue.filter((item: ICountryOption) => JSON.parse(item.value)?.countryid === "NON-EU" || !JSON.parse(item.value)?.iseumember));
    } else if (changedValue?.countryid === 'NON-EU') {
      setFieldValue(formKey, newValue.filter((item: ICountryOption) => JSON.parse(item.value)?.countryid === "EU" || JSON.parse(item.value)?.iseumember));
    } else if (changedValue?.iseumember) {
      setFieldValue(formKey, newValue.filter((item: ICountryOption) => JSON.parse(item.value)?.countryid !== "EU"));
    } else if (changedValue?.iseumember === 0) {
      setFieldValue(formKey, newValue.filter((item: ICountryOption) => JSON.parse(item.value)?.countryid !== "NON-EU"));
    } else {
      setFieldValue(formKey, newValue);
    }
  }
}
export const handleCountriesChange = (newValue: any[], currentValue: any[], countriesOptions: any[], setFieldValue: any, formKey: string) => {
  const changes = checkCountriesDiff(newValue, currentValue);
  if (changes.length) {
    // new value selected
    handleCountriesAdd(changes, newValue, countriesOptions, setFieldValue, formKey);
  } else {
    // value deselected
    const changes2 = checkCountriesDiff(currentValue, newValue);
    handleCountriesRemove(changes2, newValue, setFieldValue, formKey);
  }
}

export const BOOTSTRAP_CLASSES = {
  IS_INVALID: "is-invalid"
}

export const isIE = () => {
  // @ts-ignore
  return false || !!document.documentMode;
}

export const checkDateForNotifications = () => {
  const currentDate = moment.utc();
  const startDate = moment.tz("08:00:00", "HH:mm:ss", "Europe/Brussels");
  const endDate = moment.tz("18:00:00", "HH:mm:ss", "Europe/Brussels");

  return currentDate.isAfter(startDate) && currentDate.isBefore(endDate);
}

export const compareResults = (sortBy: { id: string, desc: boolean}) => {
  return function (a: any, b: any) {
    const varA = a[sortBy["id"]] || "";
    const varB = b[sortBy["id"]] || "";

    if (varA.toString().toLowerCase() > varB.toString().toLowerCase()) {
      return sortBy["desc"]?-1:1;
    } else if (varA.toString().toLowerCase() < varB.toString().toLowerCase()) {
      return sortBy["desc"]?1:-1
    }
    return 0;
  };
}

export const logoutAndDeleteStorage = (redirect: boolean) => {
  sessionStorage.clear();
  localStorage.clear();
  if (redirect) {
    window.location.replace(process.env.REACT_APP_LOGIN_URL!)
  }
}

export const getFileFormat = ( file: any ) => {
  return (file)?(file.match(/\.([^.]+)$/)[1]):"";
}

export const getFileIcon = ( fileFormat: any ) => {
  switch (fileFormat) {
    case 'jpeg':
    case 'jpg':
    case 'png':
      return ['far', 'file-image'];
    case 'docx':
    case 'doc':
      return ['far', 'file-word'];
    case 'xlsx':
    case 'xls':
      return ['far', 'file-excel'];
    case 'pdf':
      return ['far', 'file-pdf'];
    case 'csv':
      return ['fas', 'file-csv'];
    default:
      return ['far', 'file'];
  }
}

export const denominationStatusMatching = ( denominationStatus: any ) => {
  switch ( denominationStatus ) {
    case 'Proposed':
      return i18n.t('proposed');
    case 'Published':
      return i18n.t('published');
    case 'Approved':
      return i18n.t('approved');
    case 'Rejected or Withdrawn':
      return i18n.t('rejected_withdrawn');
    case 'Cancelled':
      return i18n.t('cancelled');
    default:
      return denominationStatus;
  }
}

export const calcFileSize = (size: any) => {
  if (size === 0) {
    return '0 Bytes';
  }
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(size) / Math.log(k));
  return `${parseFloat((size / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

export const sleep = (ms: any) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const getProtectedDesignation = (country: string, pub_type_id: string, publicationExtraId: number) => {
    if (country === "QZ" && pub_type_id === "ZZZ") {
        switch (publicationExtraId) {
            case 3:
                return 'pdo';
            case 4:
                return 'pgi';
            case 5:
                return 'tsg';
            default:
                return "";
        }
    }
    else {
        return "";
    }
};

export const chunkArray = (array: any[], limits: any[], size: number) => {
  const chunked_arr: any[] = [];
  let startIndex = 0;
  let currentIndex = 0;
  let currentLines = 0;
  array.forEach((row: any) => {
    currentIndex++;
    let lines = 1;
    limits.forEach((limit: any) => {
      if (row[limit.name]?.length > limit.size) {
        let rowLines = countColumnLines(row[limit.name], limit.size);
        if (rowLines > lines) {
          lines = rowLines;
        }
      }
    });
    currentLines += lines;
    if (currentLines > size) {
      chunked_arr.push(array.slice(startIndex, currentIndex - 1));
      startIndex = currentIndex;
      currentLines = 0;
    }
  })
  chunked_arr.push(array.slice(startIndex === 0 ? startIndex : startIndex - 1));
  return chunked_arr;
}

const countColumnLines = (value: string, lineSize: number) => {
  return Math.ceil(value.length/lineSize)
}
